import type { EditingPaymentRequest } from './use-editing-payment.js';
import { financeSummary } from './shoot-finance.js';
import { SessionResponse, type SessionStatus, type SessionSummary } from '@diana/contracts';
import { AdminApiError, type AdminApiClient } from '../../lib/api-client.js';
import { sessionDraft } from './crm-format.js';

/** Fetch the complete aggregate; never rebuild a PUT from a list summary. */
export async function moveShoot(
  api: AdminApiClient,
  shoot: SessionSummary,
  status: SessionStatus,
  payment?: EditingPaymentRequest,
) {
  const { session } = await api.get(`/api/v1/admin/sessions/${shoot.id}`, SessionResponse);
  if (session.revision !== shoot.revision) {
    throw new AdminApiError(
      409,
      'REVISION_CONFLICT',
      'conflict',
      'This shoot changed. Refresh and try again.',
    );
  }
  if (session.status === status) return { session };
  if (
    status === 'Delivered' ||
    (status === 'Editing' &&
      (financeSummary(session.priceAmountMinor, session.transactions ?? []).remaining ?? 0) > 0)
  ) {
    if (!payment)
      throw new Error(
        status === 'Delivered'
          ? 'Confirm the gallery link before changing to Delivered'
          : 'Confirm the remaining payment before changing to Editing',
      );
    let response: { session: typeof session } | undefined;
    const accepted = await payment({ ...sessionDraft(session), status }, async (draft) => {
      response = await api.request(`/api/v1/admin/sessions/${shoot.id}`, {
        method: 'PUT',
        body: { ...draft, expectedRevision: session.revision },
        schema: SessionResponse,
      });
      return true;
    });
    if (!accepted) return { session, canceled: true as const };
    return response!;
  }
  return api.request(`/api/v1/admin/sessions/${shoot.id}`, {
    method: 'PUT',
    body: { ...sessionDraft(session), status, expectedRevision: session.revision },
    schema: SessionResponse,
  });
}
